import React, { useState, useEffect } from 'react';
import axios from 'axios';
import UrlForm from './components/UrlForm';
import UrlList from './components/UrlList';

function App() {
  const [urls, setUrls] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  // Fetch all URLs on component mount
  useEffect(() => {
    fetchUrls();
  }, []);

  const fetchUrls = async () => {
    try {
      setLoading(true);
      const response = await axios.get('https://surl.yz87.org/urls/');
      setUrls(response.data);
      setError('');
    } catch (err) {
      console.error('Error fetching URLs:', err);
      setError('Failed to load URLs. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  const handleUrlAdded = (newUrl) => {
    setUrls([newUrl, ...urls]);
  };

  return (
    <div className="container">
      <h1 className="title">Personal URL Shortener</h1>
      
      <UrlForm onUrlAdded={handleUrlAdded} />
      
      {loading ? (
        <div className="card">Loading URLs...</div>
      ) : error ? (
        <div className="card" style={{ color: 'red' }}>{error}</div>
      ) : (
        <UrlList urls={urls} />
      )}
    </div>
  );
}

export default App;
